import { useCallback } from 'react';
import { createFileRoute } from '@tanstack/react-router';

import { USER_ROLES } from '~/features/auth/roles';
import { authState } from '~/features/auth/state';
import { getDepartmentTabsLength } from '~/features/department/constants';
import { DepartmentDetailsScreen } from '~/features/department/DepartmentDetailsScreen';
import type { DepartmentDetailsSearchParams } from '~/features/department/types';
import { protectedRoute } from '~/utils/routesAuthorization';

export const Route = createFileRoute(
  '/user-administration/departments/$departmentId',
)({
  component: RouteComponent,
  params: {
    parse: (params) => ({ departmentId: params.departmentId }),
  },
  validateSearch: (search): DepartmentDetailsSearchParams => {
    const { userInfo } = authState.get();

    let tab = Number(search.tab ?? 0);

    // Index out of bounds
    if (tab < 0 || tab >= getDepartmentTabsLength(userInfo?.role)) {
      tab = 0;
    }

    return { tab };
  },
  beforeLoad: () => {
    protectedRoute({
      roles: [USER_ROLES.HcpAdmin, USER_ROLES.NonHcpAdmin],
    });
  },
});

function RouteComponent() {
  const navigate = Route.useNavigate();
  const { tab: selectedTabIndex } = Route.useSearch();
  const { departmentId } = Route.useParams();

  const setSelectedTabIndex = useCallback(
    (newTabIndex: number) => {
      void navigate({
        search: { tab: newTabIndex },
      });
    },
    [navigate],
  );

  return (
    <DepartmentDetailsScreen
      departmentId={departmentId}
      selectedTabIndex={selectedTabIndex}
      setSelectedTabIndex={setSelectedTabIndex}
    />
  );
}
